import React, { useEffect, useState } from 'react';
import { styled } from '@mui/material/styles';
import Paper from '@mui/material/Paper';
import { Box, Button, Select, Typography, MenuItem, FormHelperText, Chip, Divider, Grid } from '@mui/material';
import { fetchToken } from '../auth/Token';
import { api } from '../api';
import Dialog from '@mui/material/Dialog';
import { useLocation, useNavigate } from 'react-router-dom';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import TextField from '@mui/material/TextField';
import Snackbar from '@mui/material/Snackbar';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import { useFormik, validateYupSchema } from 'formik';
import * as Yup from 'yup';
import Autocomplete from '@mui/material/Autocomplete';
import Backdrop from '@mui/material/Backdrop';
import { DataGrid, GridToolbar, GridRowParams, GridActionsCellItem} from '@mui/x-data-grid';
import CircularProgress from '@mui/material/CircularProgress';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import Modal from '@mui/material/Modal';
import { Commodities } from './../pages/Commodities';
import dayjs from 'dayjs';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import Tooltip from '@mui/material/Tooltip';
import {FormatedDate} from './SavingsDetails';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import FilterAltOutlinedIcon from '@mui/icons-material/FilterAltOutlined';
import CancelIcon from '@mui/icons-material/Cancel';
import AssignmentIcon from '@mui/icons-material/Assignment';
import SummarizeIcon from '@mui/icons-material/Summarize';
import html2canvas from 'html2canvas';
import { jsPDF } from 'jspdf';
import './../working.css';
import { toast } from 'sonner';


function DemChips(props){
  return (
  <Chip label={
    <div style={{ display: 'block' }}>
      <Typography sx={{ mb:1, mr:1 }} fontStyle='Italic' variant='subtitle'>Id: <b>{props.id}</b></Typography>
      <Typography sx={{ mb:1, mr:1 }} fontStyle='Italic' variant='subtitle'>Date: <b><FormatedDate value={props.date} /></b></Typography>
      <Typography sx={{ mb:1, mr:1 }} fontStyle='Italic' variant='subtitle'>Bags: <b>{props.bags}</b></Typography>
      <Typography sx={{ mb:1, mr:1 }} fontStyle='Italic' variant='subtitle'>Grade: <b>{props.grade}</b></Typography>
      <Typography sx={{ mb:1, mr:1 }} fontStyle='Italic' variant='subtitle'>Unit: <b>{props.unit}</b></Typography>
      <Typography fontStyle='Italic' variant='subtitle'>Worth: <b>{props.cash}</b></Typography>
    </div>
  } 
  key={props.id}
  />
  )
}


function MoreComDetails(
  {commodity,
   units, 
   total_number, 
   commodity_cash_value, 
   total_weight, 
   tonnes, 
   grade, 
   commodity_id, 
   acc_id,
   member,
   kind,
   society,
   association,
   passbook,
   warehouse,
  }){
  const [current_prices, setCurrent_prices] = useState([]);
  const [modal_Open, setModal_open] = useState(false);
  const [modal_Open_no, setModal_open_no] = useState(false)
  const [modal_Open_no_ret, setModal_open_no_ret] = useState(false);
  const [acts, setActs] = useState([]);
  const [total_cash_value, setTotal_cash_value] = useState();
  const [total_bags, setTotal_bags] = useState();
  const [total_balance, setTotal_balance] = useState();

  const sec_style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 620,
    maxHeight: '80vh', 
    overflowY: 'auto', 
    bgcolor: 'background.paper',
    border: '1px solid #e7ecef',
    borderRadius: '7px',
    boxShadow: 24,
    p: 4,
  };

  const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '1180px',
    maxHeight: '150vh', 
    overflowY: 'auto', 
    bgcolor: 'background.paper',
    border: '1px solid #e7ecef',
    borderRadius: '7px',
    boxShadow: 24,
    p: 4,
  };

  const handle_modal_Closee = () => {
    setModal_open(false)
  }

  const currencyFormat = new Intl.NumberFormat('en-GH', {
    style: 'currency',
    currency: 'GHS',
  });

  useEffect(()=>{
    api.get(`/account/current/prices/${commodity_id}`,{
        headers: {
          Authorization: 'Bearer ' + fetchToken()
        }
      }).then(function (response){
        setCurrent_prices(response.data?.price);
      })
  },[])

  const [start_date, setStart_date] = useState('')
  const [end_date, setEnd_date] = useState('')

  const fetch_activities = () => {
    const info = new FormData()
    info.append('member_com_acc_id', acc_id)
    info.append('commodity_id', commodity_id)
    info.append('start_date', start_date)
    info.append('end_date', end_date)


    api.post('/account/my/activities/commodity', info,{
        headers: {
          Authorization: 'Bearer ' + fetchToken()
        }
      }).then(function (response){
        setActs(response.data?.activities);
        setTotal_cash_value(response.data?.total_cash_value)
        setTotal_bags(response.data?.total_bags)
        setTotal_balance(response.data?.total_balance)
      })
  }

  const clear_filter = () => {
    setStart_date('')
    setEnd_date('')
    fetch_activities();
  }

  useEffect(()=>{
    fetch_activities();
  },[])

  

  const columns = [
    {
      field: "transaction_id",
      headerName: "Id",
      flex: 1,
    },
    {
      field: "transaction_date",
      headerName: "DateTime",
      flex: 1,
      renderCell:(params) => <FormatedDate value={params.row.transaction_date}/>
    },
    {
      field: "commodity",
      headerName: "Commodity",
      flex: 1,
    },
    {
      field: "amount_of_commodity",
      headerName: "Bags Stored",
      flex: 1,
    },
    {
      field: "cash_value",
      headerName: "Cash value(GHS)",
      flex: 1,
      renderCell:(params) => currencyFormat.format(params.row.cash_value)
    },
    {
      field: "transaction_type_id",
      headerName: "Act",
      flex: 1,
      renderCell:(params) => params.row.transaction_type_id === 1?'Store':  'Retrieve'
    },
    {
      field: "grade",
      headerName: "Grade",
      flex: 1,
    },
    {
      field: "unit_per_kg",
      headerName: "Units(kg)",
      flex: 1,
    },
    {
      field: "username",
      headerName: "Prepared by",
      flex: 1,
    },
    {
      field: "total_cash_balance",
      headerName: "Cash Balance",
      flex: 1,
      renderCell:(params) => currencyFormat.format(params.row.total_cash_balance)
    },
    {
      field: "view",
      type:'actions',
      width:20,
      getActions: (params: GridRowParams) => [
      <GridActionsCellItem
      icon={<SummarizeIcon />}
      onClick={() => handle_print({params})} 
      label="View"
      />,]
    },
    {
      field: 'delete',
      type: 'actions',
      width:20,
      getActions: (params: GridRowParams) => [
      <GridActionsCellItem
      icon={<DeleteIcon />}
      onClick={() => handleClickOpen(params.row.transaction_id)} 
      label="Open"
      />,]
    },
  ]
  const [date, setDate] = useState()
  const [mini_loading, setMini_loading] = useState(false)

  const handle_print = async ({ params }) => {
    setMini_loading(true)
    setDate(params.row.transaction_date);
    await proccess_info({ params });
  };

  const [confirm_request, setConfirm_request] = useState([]);
  const [processingComplete, setProcessingComplete] = useState(false);
  const [fees, setFees] = useState([]);
  
  const proccess_info = ({params}) => {
    api.get(`/account/act/details/edit/${params.row.transaction_id}` ,{
      headers: {
        Authorization: 'Bearer ' + fetchToken()
      }
    }).then(function (response){
        setFees(response.data?.details)
      const data = new FormData()
      data.append('commodity_id', commodity_id)
      data.append('grade_id', response.data?.details.grade_id)
      data.append('unit_id', response.data?.details.units_id)
      data.append('amount_storing', response.data?.details.amount_of_commodity)
      data.append('member_com_acc', acc_id)
      data.append('rebag', response.data?.details.rebagging_fee)
      data.append('stack', response.data?.details.stacking_fee)
      data.append('clean', response.data?.details.cleaning_fee)
      data.append('destone', response.data?.details.destoning_fee)
      data.append('store', response.data?.details.storage_fee)
      data.append('stitch', response.data?.details.stitching_fee)
      data.append('load', response.data?.details.loading_fee)
      data.append('empty_sack', response.data?.details.empty_sack_cost_fee)
      api.post('/account/process/storage', data ,{
        headers: {
          Authorization: 'Bearer ' + fetchToken()
        }
      }).then(function (response){
        setConfirm_request(response.data);
        setProcessingComplete(true);
        if (params.row.transaction_type_id === 2){
          setModal_open_no_ret(true)
        }else{
          setModal_open_no(true)
        }
      }).catch(function (error){
        console.log(error)
      })

    }).catch(function (error){
      console.log(error)
    })
  }

  const printRef = React.useRef();
  const printRef_ret = React.useRef();

  const handlePrint = async () => {
    const element = printRef.current;
    const canvas = await html2canvas(element);
    const data = canvas.toDataURL('image/png');
  
    const pdf = new jsPDF();
    const imgProperties = pdf.getImageProperties(data);
    const pdfWidth = pdf.internal.pageSize.getWidth();
    const pdfHeight = (imgProperties.height * pdfWidth) / imgProperties.width;
  
    
    const marginLeft = 25;
    const marginTop = 25;
    const marginRight = 25;
    const marginBottom = 25; 
  
    pdf.addImage(
      data,
      'PNG',
      marginLeft,
      marginTop,
      pdfWidth - marginLeft - marginRight,
      pdfHeight - marginTop - marginBottom
    );
  
    pdf.save('CommodityStorage.pdf');
    setMini_loading(false)
    setModal_open_no(false)
  };

  const handlePrint_ret = async () => {
    const element = printRef_ret.current;
    const canvas = await html2canvas(element);
    const data = canvas.toDataURL('image/png');
  
    const pdf = new jsPDF();
    const imgProperties = pdf.getImageProperties(data);
    const pdfWidth = pdf.internal.pageSize.getWidth();
    const pdfHeight = (imgProperties.height * pdfWidth) / imgProperties.width;
  
    
    const marginLeft = 25;
    const marginTop = 25;
    const marginRight = 25;
    const marginBottom = 25; 
  
    pdf.addImage(
      data,
      'PNG',
      marginLeft,
      marginTop,
      pdfWidth - marginLeft - marginRight,
      pdfHeight - marginTop - marginBottom
    );
  
    pdf.save('CommodityRetrieval.pdf');
    setMini_loading(false)
    setModal_open_no_ret(false)
  };

  // useEffect(() => {
  //   console.log("confirm_request:", confirm_request);
  //   console.log("processingComplete:", processingComplete);
  //   if (confirm_request.Grade) {
  //     if (processingComplete) {
  //       handlePrint();
  //       setMini_loading(false);
  //     }
  //   }
  // }, [confirm_request, processingComplete]);





  const [messageid, setMessageid] = useState();
  const [openn, setOpenn] = useState(false);

  const handleClickOpen = (id) => {
    setOpenn(true);
    setMessageid(id)
  }

  const hangcloo = () =>{
    setMessageid()
    setOpenn(false);
  }

  const handleDelete = () => {
    // handleOpen()
    const id = messageid
        api.delete(`/account/movetotrash/${id}`,{
            headers :{
            Authorization: 'Bearer '+ fetchToken()
            }
        }).then(function (response){
            toast.success(response.data)
            setOpenn(false)
            fetch_activities();
        }).catch(function (error){
            console.log(error)
        }).finally(function (){
          // handleClose()
          hangcloo()
        })
}; 

  const CustomFooterRow = () =>{
    return (
      <div>
        <div style={{ display: 'flex', padding: '4px' }}>
          <Typography variant="h6" sx={{ mr:4 }}><b>Total:</b></Typography>
          <Typography variant="h6" sx={{ mr:4 }}><b>Cash Value: {currencyFormat.format(total_cash_value)}</b> </Typography>
          <Typography variant="h6" sx={{ mr:4 }}><b>Bags: {total_bags}</b> </Typography>
          <Typography variant="h6" sx={{ mr:4 }}><b>Cash Balance: {currencyFormat.format(total_balance)}</b> </Typography>
         </div>
      </div>
    );
  }

  const closeam =()=>{
    setMini_loading(false)
    setModal_open_no(false)
  }

  const handle_modal_Closee_ret = () => {
    setModal_open_no_ret(false)
  }


  const [charges, setCharges] = useState([])

  useEffect(()=>{
    api.get(`/account/commodities/charges/${acc_id}`, {
      headers: {
        Authorization: 'Bearer ' + fetchToken()
      }
    }).then(function (response){
      setCharges(response.data);
    })
  },[modal_Open_no])


  return(
    <Grid container spacing={1} sx={{ mb:4 }}>
      <Grid item xs={12} md={7}>
        <Typography variant='h6' fontStyle='italic'>Commodity: <b>{commodity}</b></Typography>
        <Tooltip title={
          current_prices && current_prices.map((item)=>(
          <div style={{ display: 'block' }}>
            <Chip
              key={item.id}
              label={<b><i>{`${item.grade}: ${currencyFormat.format(item.price_per_kg)}/kg`}</i></b>}
              size='small'
              variant='outlined'
              sx={{ color:'#000',m:1 }}
            />
            </div>
          ))
        } followCursor leaveDelay={500} placement='right'>
            <Typography variant='subtitle' fontStyle='italic' sx={{ m:2,color: 'brown' }}>See Current Prices</Typography>
        </Tooltip>
        <Divider variant='middle'/>
        <Typography variant='h6' fontStyle='italic'>Units: <b>{units}</b></Typography>
        <Divider variant='middle'/>
        <Typography variant='h6' fontStyle='italic'>Total number of bags: <b>{total_number}</b></Typography>
        <Divider variant='middle'/>
        <Typography variant='h6' fontStyle='italic'>Current cash value: <b>{currencyFormat.format(commodity_cash_value)}</b></Typography>
        <Divider variant='middle'/>
        <Typography variant='h6' fontStyle='italic'>Commodity Weight: <b>{total_weight}kg</b></Typography>
        <Divider variant='middle'/>
        <Typography variant='h6' fontStyle='italic'>Tonnes(excluding retrievals): <b>{tonnes}</b></Typography>
        <Divider variant='middle'/>
        <Typography variant='h6' fontStyle='italic'>Grades: <b>{grade}</b></Typography>
      </Grid>

      <Grid item xs={12} md={4}>
        <Button
          onClick={()=>setModal_open(true)}
          sx={{ borderRadius: 6, backgroundColor: '#99d98c' }}
          size='medium'
          variant='contained'
          startIcon={<AssignmentIcon />}
        >
          <b><i>See Activities</i></b>
        </Button>
        <Modal
            open={modal_Open}
            onClose={handle_modal_Closee}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
        >
          <Box sx={style}>
          <Typography variant="button" display="block" gutterBottom><b>My Activities</b></Typography>
              <>
                <Typography>Filter Date</Typography>
                <div style={{ display:'flex' }}>
                <TextField
                    type='date'
                    size="small"
                    required 
                    variant="outlined"
                    helperText="From"
                    name="start_date"
                    onChange={(e) => setStart_date(e.target.value)}
                    value={start_date}
                    sx={{ mr:1 }}
                />

                <TextField
                    type='date'
                    size="small"
                    required
                    variant="outlined"
                    helperText="To"
                    name="end_date"
                    onChange={(e) => setEnd_date(e.target.value)}
                    value={end_date}
                    sx={{ mr:1 }}
                />

                  <IconButton sx={{ mb:2 }} onClick={fetch_activities}><FilterAltOutlinedIcon /></IconButton>
                  <IconButton sx={{ mb:2 }} onClick={clear_filter}><CancelIcon /></IconButton>
                </div>
              </>
              <DataGrid
                  rows={acts}
                  columns={columns}
                  loading={mini_loading}
                  checkboxSelection
                  getRowId={(row) => row.transaction_id}
                  sortingOrder={['desc', 'asc']}
                  sortModel={[
                  {
                      field: 'transaction_id',
                      sort: 'desc',
                  },
                  ]}
                  slots={{ toolbar: GridToolbar, footer: CustomFooterRow }}
                  initialState={{
                      columns: {
                        columnVisibilityModel: {
                          transaction_id: false,
                        },
                      },
                    }}
              />
              <Button
                onClick={handle_modal_Closee}
                sx={{ borderRadius: 3, mt:3 }}
                size='small'
                color='error'
                variant='contained'
              >
                Close
              </Button>
          </Box>
        </Modal>

        <Modal
            open={modal_Open_no}
            onClose={closeam}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
        >
              {
                confirm_request?
          <Box sx={sec_style}>
                  <>
                    <div ref={printRef} style={{ display:'block', marginBottom:5 }}>
                        <Typography fontStyle='Italic' variant='body2' sx={{ textAlign: 'center',mb:2}}>~The Cooperative~</Typography>

                        <Typography variant='h5' fontStyle='italic'>Commodity Storage</Typography>
                        <Chip sx={{ display:'flex', mt:1, mb:1  }} label={confirm_request.Commodity} variant='outlined' color='success'/>
                        <Divider variant='middle' sx={{mt:1, mb:1}}><i>Member Details</i></Divider>

                        <div>
                          <Typography fontStyle='Italic' variant='body2'>Date: <b style={{color:'black'}}> <FormatedDate value={date}/></b></Typography>
                          <Typography fontStyle='Italic' variant='body2'>Member: <b style={{color:'black'}}>{member}</b></Typography>
                          <Typography fontStyle='Italic' variant='body2'>Passbook: <b style={{color:'black'}}>{passbook}</b></Typography>
                          <Typography fontStyle='Italic' variant='body2'>Society: <b style={{color:'black'}}>{society}</b></Typography>
                          <Typography fontStyle='Italic' variant='body2'>Kind: <b style={{color:'black'}}>{kind}</b></Typography>
                          <Typography fontStyle='Italic' variant='body2'>Savings Group: <b style={{color:'black'}}>{association}</b></Typography>
                          <Typography fontStyle='Italic' variant='body2'>Warehouse: <b style={{color:'black'}}>{warehouse}</b></Typography>
                        </div>

                        <Divider variant='middle' sx={{mt:2, mb:2}}><i>Commodity Specification</i></Divider>
                        <div style={{ display:'flex', justifyContent:'space-between' }}>
                        <div style={{ display:'block' }}>
                          <Typography variant='h6' fontStyle='italic'>Grade: <b>{confirm_request.Grade}</b> </Typography>
                          <Typography variant='h6' fontStyle='italic'>Current {confirm_request.Commodity} price: <b>{currencyFormat.format(confirm_request.Current_commodity_price)}</b> </Typography>
                          <Typography variant='h6' fontStyle='italic'>Number of Bags: <b>{confirm_request.Amount_storing} </b> </Typography>
                          <Typography variant='h6' fontStyle='italic'>Units: <b>{confirm_request.Unit_kg}kg</b> </Typography>
                          <Typography variant='h6' fontStyle='italic'>Weight: <b>{confirm_request.Weight}kg </b> </Typography>
                          <Typography variant='h6' fontStyle='italic'>Tonnes: <b>{confirm_request.Tons}</b> </Typography>
                          <Typography variant='h6' fontStyle='italic'>Price per bag (Original): <b>{currencyFormat.format(confirm_request.Price_per_bag)}</b> </Typography>
                          <Typography variant='h6' fontStyle='italic'>Price per bag (Charged): <b>{currencyFormat.format(confirm_request.charged_price_per_bg)}</b> </Typography>
                          <Typography variant='h6' fontStyle='italic'>Current cash value: <b>{currencyFormat.format(confirm_request.total_cash_value)}</b> </Typography>
                        </div>
                        <div style={{ display:'block', marginLeft:'3px', borderColor:'blue' }}>
                          {
                            charges[0]?
                            <>
                              <Typography variant='subtitle' fontStyle='oblique' fontFamily='Futura'><b><u>Charges associated</u></b></Typography>
                              <Typography variant='h6' fontStyle='italic'>Rebag ({currencyFormat.format(charges[0].rebagging_fee)}): <b>{fees.rebagging_fee === true? 'paid':'no rebaging'}</b> </Typography>
                              <Typography variant='h6' fontStyle='italic'>Stack ({currencyFormat.format(charges[0].stacking_fee)}): <b>{fees.stacking_fee === true? 'paid':'no stacking'}</b> </Typography>
                              <Typography variant='h6' fontStyle='italic'>Clean ({currencyFormat.format(charges[0].cleaning_fee)}): <b>{fees.cleaning_fee === true? 'paid':'no cleaning'}</b> </Typography>
                              <Typography variant='h6' fontStyle='italic'>Destone ({currencyFormat.format(charges[0].destoning_fee)}): <b>{fees.destone === true? 'paid':'no destoning'}</b> </Typography>
                              <Typography variant='h6' fontStyle='italic'>Store ({currencyFormat.format(charges[0].storage_fee)}): <b>{fees.storage_fee === true? 'paid':'no storage_fee'}</b> </Typography>
                              <Typography variant='h6' fontStyle='italic'>Stitch ({currencyFormat.format(charges[0].stitching_fee)}): <b>{fees.stitching_fee === true? 'paid':'no stitching'}</b> </Typography>
                              <Typography variant='h6' fontStyle='italic'>Load ({currencyFormat.format(charges[0].loading_fee)}): <b>{fees.loading_fee === true? 'paid':'no loading'}</b> </Typography>
                              <Typography variant='h6' fontStyle='italic'>Empty Sack ({currencyFormat.format(charges[0].empty_sack_cost_fee)}): <b>{fees.empty_sack_cost_fee === true? 'paid':'no empty sack'}</b> </Typography>
                              <Typography variant='h6' fontStyle='italic'>Tax ({currencyFormat.format(charges[0].tax_fee)}): <b>paid</b> </Typography>
                            </>
                            :
                            <Box sx={{ width: '100%', justifyContent:'center' }}>
                                <CircularProgress size='15'/>
                            </Box>
                          }
                        
                        </div>
                      </div>

                    </div>
                        <Typography sx={{ mt:2 }} variant='subtitle' fontStyle='italic'>Print:</Typography>
                        <IconButton onClick={handlePrint}><SummarizeIcon size='small'/></IconButton>
                    <div style={{ display:'flex', flexDirection: 'row', marginLeft:320 }}>
                    <Button
                      variant='contained'
                      onClick={closeam}
                      color='error'
                      size='small'
                      sx={{ mr:1 }}
                    >
                        Cancel
                    </Button>
                    </div>
                  </>
          </Box>
                :
                <Box sx={{ width: '100%', justifyContent:'center' }}>
                  <CircularProgress size='15'/>
                </Box>
              }
        </Modal>


              {/* Retrieval */}
          <Modal
            open={modal_Open_no_ret}
            onClose={handle_modal_Closee_ret}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
              {
                confirm_request?
            <Box sx={sec_style}>
                  <>
                    <div ref={printRef_ret} style={{ display:'block', marginBottom:5 }}>
                        <Typography fontStyle='Italic' variant='body2' sx={{ textAlign: 'center',mb:2}}>~The Cooperative~</Typography>

                        <Typography variant='h5' fontStyle='italic'>Commodity Retrieval</Typography>
                        <Chip sx={{ display:'flex', mt:1, mb:1  }} label={confirm_request.Commodity} variant='outlined' color='success'/>
                        <Divider variant='middle' sx={{mt:1, mb:1}}><i>Member Details</i></Divider>
                        <div>
                          <Typography fontStyle='Italic' variant='body2'>Date: <b style={{color:'black'}}> <FormatedDate value={date}/></b></Typography>
                          <Typography fontStyle='Italic' variant='body2'>Member: <b style={{color:'black'}}>{member}</b></Typography>
                          <Typography fontStyle='Italic' variant='body2'>Passbook: <b style={{color:'black'}}>{passbook}</b></Typography>
                          <Typography fontStyle='Italic' variant='body2'>Society: <b style={{color:'black'}}>{society}</b></Typography>
                          <Typography fontStyle='Italic' variant='body2'>Kind: <b style={{color:'black'}}>{kind}</b></Typography>
                          <Typography fontStyle='Italic' variant='body2'>Savings Group: <b style={{color:'black'}}>{association}</b></Typography>
                          <Typography fontStyle='Italic' variant='body2'>Warehouse: <b style={{color:'black'}}>{warehouse}</b></Typography>
                        </div>

                        <Divider variant='middle' sx={{mt:2, mb:2}}><i>Commodity Specification</i></Divider>

                        <Typography variant='h6' fontStyle='italic'>Grade: <b>{confirm_request.Grade}</b> </Typography>
                        <Typography variant='h6' fontStyle='italic'>Current {confirm_request.Commodity} price: <b>{currencyFormat.format(confirm_request.Current_commodity_price)}</b> </Typography>
                        <Typography variant='h6' fontStyle='italic'>Bags retrieving: <b>{confirm_request.Amount_storing} </b> </Typography>
                        <Typography variant='h6' fontStyle='italic'>Units: <b>{confirm_request.Unit_kg}kg</b> </Typography>
                        <Typography variant='h6' fontStyle='italic'>Weight: <b>{confirm_request.Weight}kg </b> </Typography>
                        <Typography variant='h6' fontStyle='italic'>Tonnes: <b>{confirm_request.Tons}</b> </Typography>
                        <Typography variant='h6' fontStyle='italic'>Price per bag (Charged): <b>{currencyFormat.format(confirm_request.Price_per_bag)}</b> </Typography>
                        <Typography variant='h6' fontStyle='italic'>Value: <b>{currencyFormat.format(confirm_request.total_cash_value)}</b> </Typography>
                       
                        
                    </div>
                        <Typography sx={{ mt:2 }} variant='subtitle' fontStyle='italic'>Print:</Typography>
                        <IconButton onClick={handlePrint_ret}><SummarizeIcon size='small'/></IconButton>
                    
                    <Button
                      variant='contained'
                      onClick={handle_modal_Closee_ret}
                      color='error'
                      size='small'
                      sx={{ mr:1 }}
                    >
                        Cancel
                    </Button>
                  </>
          </Box>
                :
                <Box sx={{ width: '100%', justifyContent:'center' }}>
                  <CircularProgress size='15'/>
                </Box>
              }
        </Modal>



          <Dialog
                open={openn}
                onClose={hangcloo}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
            <DialogTitle id="alert-dialog-title">
            {"Delete Activity"}
            </DialogTitle>
            <DialogContent>
            <DialogContentText id="alert-dialog-description">
                This action cannot be undone. NB: this will not affect the
                current state of the account.
                Do you wish to continue?
            </DialogContentText>
            </DialogContent>
            <DialogActions>
            <Button onClick={hangcloo}>Cancel</Button>
            <Button onClick={handleDelete} autoFocus>
                Continue
            </Button>
            </DialogActions>
        </Dialog>
        
      </Grid>
    </Grid>
  )
}

export default function CommodityDetails(props) {
    const [info_do, setInfo_do] = useState()
    const [StorageForm, setStorageForm] = useState(false);
    const [RetrievalForm, setRetrievalForm] = useState(false);
    const [ope, setOpe] = useState(false);
    const [message, setMessage] = useState("");
    const [commodities_info, setCommodities_info] = useState([]);
    const [grade_price, setGrade_price] = useState([]);
    const [available_units, setAvailable_units] = useState([]);
    const [modal_Open, setModal_open] = useState(false);
    const [modal_Open_ret, setModal_open_ret] = useState(false);
    const [confirm_request, setConfirm_request] = useState([]);
    const [confirm_request_ret, setConfirm_request_ret] = useState([]);
    const [responsible_trs, setResponsible_trs] = useState()
    const [unit_now, setUnit_now] = useState(null)
    const navigate = useNavigate();
    // console.log(unit_now)

    

    const handleInfoDo = (
        commodity,
        units,
        total_number,
        commodity_cash_value,
        total_weight,
        tonnes,
        grade,
        commodity_id
      ) => {
      handleOpen()
      setInfo_do(
        <MoreComDetails 
          commodity={commodity}
          units={units}
          total_number={total_number}
          commodity_cash_value={commodity_cash_value}
          total_weight={total_weight}
          tonnes={tonnes}
          grade={grade}
          commodity_id={commodity_id}
          acc_id={props.ID}
          account_id={props.ID}
          member={props.member}
          kind={props.kind}
          society={props.society}
          association={props.association}
          passbook={props.passbook}
          warehouse={props.name}
        />
      );
      handleCloses()
    }

    const [openn, setOpenn] = React.useState(false);

    const handleCloses = () => {
      setOpenn(false);
    };
    const handleOpen = () => {
      setOpenn(true);
    };

    const style = {
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      width: 620,
      maxHeight: '80vh', 
      overflowY: 'auto', 
      bgcolor: 'background.paper',
      border: '1px solid #e7ecef',
      borderRadius: '7px',
      boxShadow: 24,
      p: 4,
    };

    const styler = {
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      width: '1180px',
      maxHeight: '150vh', 
      overflowY: 'auto', 
      bgcolor: 'background.paper',
      border: '1px solid #e7ecef',
      borderRadius: '7px',
      boxShadow: 24,
      p: 4,
    };

    const handle_modal_Closee = () => {
      setModal_open(false)
      setGrade_price([]);
    }


  const formik = useFormik({
        initialValues: {
          commodity_id: null,
          grade_id: null,
          unit_id: null,
          amount_storing: null,
          member_com_acc: props.ID,
          rebag: false,
          stack: false,
          clean: false,
          destone: false,
          store: true,
          stitch: false,
          load: true,
          empty_sack: false,
          date: dayjs()
      },
      onSubmit: (values) => {
          handleOpen()
          const data = new FormData()
          data.append('commodity_id', values.commodity_id)
          data.append('grade_id', values.grade_id)
          data.append('unit_id', values.unit_id)
          data.append('amount_storing', values.amount_storing)
          data.append('member_com_acc', values.member_com_acc)
          data.append('rebag', values.rebag)
          data.append('stack', values.stack)
          data.append('clean', values.clean)
          data.append('destone', values.destone)
          data.append('store', values.store)
          data.append('stitch', values.stitch)
          data.append('load', values.load)
          data.append('empty_sack', values.empty_sack)
          data.append('date', values.date)

          api.post('/account/process/storage', data ,{
            headers: {
              Authorization: 'Bearer ' + fetchToken()
            }
          }).then(function (response){
            setConfirm_request(response.data);
            setStorageForm(false);
            setModal_open(true);
            fetch_commodity_Details();
          }).finally(function (){
            handleCloses();
          })
      }
    })



    
    
    const handleClo = (event, reason) => {
        if (reason === 'clickaway') {
          return;
        }
        setOpe(false);
      };
  
      const actio = (
        <React.Fragment>
          <IconButton
            size="small"
            aria-label="close"
            color="inherit"
            onClick={handleClo}
          >
            <CloseIcon fontSize="small" />
          </IconButton>
        </React.Fragment>
      );


    const Item = styled(Paper)(({ theme }) => ({
        backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
        ...theme.typography.body2,
        padding: theme.spacing(1),
        textAlign: 'center',
        color: theme.palette.text.secondary,
      }));


        const fetch_commodity_Details = () => {
            try{
                api.get(`/account/commodities/warehouse/${props.ID}`,{
                    headers: {
                        Authorization: 'Bearer ' + fetchToken()
                    } 
                }).then(function (response){
                  setCommodities_info(response.data?.Commodities)
                })
                    
                
            } catch (error) {
                console.log('This is the error'+error)
            }
        }

        


      useEffect(() => {
        fetch_commodity_Details();
      },[])

      const handleClose = () => {
        props.setOpen_acc();
      };

      const handleStore = () => {
        setStorageForm(true)
      };

      
      

      const [open, setOpen] = useState(false);

    const handleDeleteAcc = () =>{
        api.delete(`account/delete_acc/commodity/${props.ID}`, {
            headers: {
                Authorization: 'Bearer '+fetchToken()
            },
        }).then(function (response){
            setOpen(false);
            toast.success(response.data)
            if(response.data === "Account Deleted"){
               props.fetchAccounts();
                handleClose(); 
            }
        }).catch(function (error){
            console.log(error);
        })
    }

    const [charges, setCharges] = useState([])

    useEffect(()=>{
      api.get(`/account/commodities/charges/${props.ID}`, {
        headers: {
          Authorization: 'Bearer ' + fetchToken()
        }
      }).then(function (response){
        setCharges(response.data);
      })
    },[StorageForm])
    


    
  const closeStore = () => {
    formik.handleReset()
    setStorageForm(false)
    setGrade_price([]);
  };

  const closeRetrive = () => {
    reformik.handleReset()
    setRetrievalForm(false)
    setResponsible_trs();
  }

  
  useEffect(()=>{
    if (formik.values.commodity_id){
      handleOpen()
      api.get(`/account/grade/values/${formik.values.commodity_id}`, {
        headers: {
          Authorization: 'Bearer ' + fetchToken()
        }
      }).then(function (response){
        console.log(response.data)
        setGrade_price(response.data?.grades);
        setAvailable_units(response.data?.units_kg);
      }).finally(function (){
        handleCloses()
      })
    }
  },[formik.values.commodity_id])

  const [more_details_i_like, setMore_details_i_like] = useState([]);

  const fetch_already_commodities = () => {
    api.get(`/account/com/transaction/details/${props.ID}`, {
      headers: {
        Authorization: 'Bearer ' + fetchToken()
      }
    }).then(function (response){
      setMore_details_i_like(response.data?.Commodities);
    });
  }

  useEffect(()=>{
    fetch_already_commodities()
  },[])
  
  const [loading, setLoading] = useState(false)

  const handleConfirmOrder = () => {
    setLoading(true)
    const sk = new FormData()
    sk.append('transaction_date', formik.values.date) 
    sk.append('commodity_acc_id', props.ID)
    sk.append('number_of_commodities', formik.values.amount_storing)
    sk.append('commodities_id',formik.values.commodity_id)
    sk.append('cash_value', confirm_request.total_cash_value)
    sk.append('transaction_type_id', 1)
    sk.append('grade_id', formik.values.grade_id)
    sk.append('units_id', formik.values.unit_id)
    sk.append('weight', confirm_request.Weight)
    sk.append('tons', confirm_request.Tons)
    sk.append('rebag',formik.values.rebag)
    sk.append('stack',formik.values.stack)
    sk.append('clean',formik.values.clean)
    sk.append('destone',formik.values.destone)
    sk.append('stitch',formik.values.stitch)
    sk.append('date',formik.values.date)
    sk.append('empty_sack',formik.values.empty_sack)
    sk.append('prod_id', 0)
    toast.promise(
      api.post('/account/store/commodity/original', sk, {
        headers: {
          Authorization: 'Bearer ' + fetchToken(),
          'Content-Type': 'multipart/form-data', 
          
        }
      }),
      {
        loading: "Proccessing...",
        success: (response) => {
          formik.handleReset();
          handle_modal_Closee();
          props.fetchAccounts();
          setGrade_price([]);
          fetch_already_commodities();

          return response.data
        },
        error: (error) => {
          setLoading(false);
          fetch_already_commodities();

          return "An error occurred, please refresh page"
        }
      }
    )
  }



  

  const currencyFormat = new Intl.NumberFormat('en-GH', {
    style: 'currency',
    currency: 'GHS',
  });

  const printRef = React.useRef();
  const printRef_ret = React.useRef();
  // const [print, setPrint] = useState()

  const handlePrint = async () => {
    const element = printRef.current;
    const canvas = await html2canvas(element);
    const data = canvas.toDataURL('image/png');
  
    const pdf = new jsPDF();
    const imgProperties = pdf.getImageProperties(data);
    const pdfWidth = pdf.internal.pageSize.getWidth();
    const pdfHeight = (imgProperties.height * pdfWidth) / imgProperties.width;
  
    
    const marginLeft = 25;
    const marginTop = 25;
    const marginRight = 25;
    const marginBottom = 25; 
  
    pdf.addImage(
      data,
      'PNG',
      marginLeft,
      marginTop,
      pdfWidth - marginLeft - marginRight,
      pdfHeight - marginTop - marginBottom
    );
  
    pdf.save('CommodityStorage.pdf');
  };

  // Retrieval
  const handlePrint_ret = async () => {
    const element = printRef_ret.current;
    const canvas = await html2canvas(element);
    const data = canvas.toDataURL('image/png');
  
    const pdf = new jsPDF();
    const imgProperties = pdf.getImageProperties(data);
    const pdfWidth = pdf.internal.pageSize.getWidth();
    const pdfHeight = (imgProperties.height * pdfWidth) / imgProperties.width;
  
    
    const marginLeft = 25;
    const marginTop = 25;
    const marginRight = 25;
    const marginBottom = 25; 
  
    pdf.addImage(
      data,
      'PNG',
      marginLeft,
      marginTop,
      pdfWidth - marginLeft - marginRight,
      pdfHeight - marginTop - marginBottom
    );
  
    pdf.save('CommodityRetrieval.pdf');
  };
  

  const handleRetrieve = () => {
    setRetrievalForm(true)
  }

  const handle_modal_Closee_ret = () => {
    setModal_open_ret(false)
  }



  const [num_komot, setNum_komot] = useState()

  const reformik = useFormik({
        initialValues: {
          commodity_id: null,
          transaction_id: null,
          amount_retrieving: null,
          member_com_acc: props.ID,
          date: dayjs()
      },
      validationSchema: Yup.object({
        amount_retrieving: Yup.number().max(num_komot, `You only have ${num_komot} bags`),
      }),
      onSubmit: (values) => {
          handleOpen()
          const data = new FormData()
          data.append('commodity_id', values.commodity_id)
          data.append('transaction_id', values.transaction_id)
          data.append('amount_retrieving', values.amount_retrieving)
          data.append('member_com_acc', values.member_com_acc)
          data.append('date', values.date)

          api.post('/account/retrive/commodities/process/done', data ,{
            headers: {
              Authorization: 'Bearer ' + fetchToken()
            }
          }).then(function (response){
            setConfirm_request_ret(response.data);
            setRetrievalForm();
            setModal_open_ret(true)
          }).finally(function (){
            handleCloses();
          })
          
      }
    })

    // const [available_bags, setAvailable_bags] = useState()

  useEffect(()=>{
    if (reformik.values.transaction_id){
      responsible_trs.map(item=> 
        item.id === reformik.values.transaction_id ?
        setNum_komot(item.bags_left)
        :
        null
        )
    }
  },[reformik.values.transaction_id])


  useEffect(()=>{
    if (reformik.values.commodity_id){
      handleOpen()
      const hh = new FormData()
      hh.append('member_acc_id', props.ID)
      hh.append('commodity_id', reformik.values.commodity_id)
      
      api.post('/account/get/specific/acts', hh,{
        headers: {
          Authorization: 'Bearer ' + fetchToken()
        }
      }).then(function (response){
        setResponsible_trs(response.data?.transactions);
      }).finally(function (){
        handleCloses()
      })
    }
  },[reformik.values.commodity_id, props.ID])

  // console.log(grade_price)

    // Retrieval

    const handleConfirmOrder_ret = () => {
      setLoading(true)
      const sk = new FormData()
      sk.append('date', reformik.values.date) 
      sk.append('transaction_id', reformik.values.transaction_id) 
      sk.append('member_com_acc', props.ID)
      sk.append('amount_retrieving', reformik.values.amount_retrieving)
      sk.append('commodity_id',reformik.values.commodity_id)
      sk.append('cash_value', confirm_request_ret.total_cash_value)
      sk.append('weight', confirm_request_ret.Weight)
      sk.append('tons', confirm_request_ret.Tons)

      api.post('/account/retrieve/commodity/original', sk, {
        headers: {
          Authorization: 'Bearer ' + fetchToken(),
          'Content-Type': 'multipart/form-data', 
          
        }
      }).then(function (response){
        reformik.handleReset();
        handle_modal_Closee_ret();
        toast.success(response.data)
        props.fetchAccounts();
        setResponsible_trs();
        setNum_komot();
      }).finally(function (){
        setLoading(false);
        fetch_already_commodities();
      })
    }

    const tradingAccount = () => {
      navigate('/trade', {state: {
        member_commodity_id: props.ID,
        society_id: props.society_id,
        warehouse: props.name,
        warehouse_id: props.ID,
        society: props.society
      }})
    }
    const [Modal_open_all, setModal_open_all] = useState(false)

    const handle_modal_Closee_all = () => {
      setModal_open_all(false)
    }



    const [start_date_all, setStart_date_all] = useState('')
    const [end_date_all, setEnd_date_all] = useState('')
    const [acts_all, setActs_all] = useState([]);
    const [total_cash_value, setTotal_cash_value] = useState();
    const [total_bags, setTotal_bags] = useState();
    const [total_balance, setTotal_balance] = useState();
    const [mini_loading, setMini_loading] = useState(false)

  const fetch_activities_all = () => {
    const info = new FormData()
    info.append('member_com_acc_id', props.ID)
    // info.append('commodity_id', null)
    info.append('start_date', start_date_all)
    info.append('end_date', end_date_all)


    api.post('/account/my/activities/commodity', info,{
        headers: {
          Authorization: 'Bearer ' + fetchToken()
        }
      }).then(function (response){
        setActs_all(response.data?.activities);
        setTotal_cash_value(response.data?.total_cash_value)
        setTotal_bags(response.data?.total_bags)
        setTotal_balance(response.data?.total_balance)
      })
  }

  const openoo_open = () => {
    fetch_activities_all()
    setModal_open_all(true)
  }

  const clear_filter_all = () => {
    setStart_date_all('')
    setEnd_date_all('')
    fetch_activities_all();
  }

  useEffect(()=>{
    fetch_activities_all();
  },[])

  const columns_all = [
    {
      field: "id",
      headerName: "Id",
      flex: 1,
    },
    {
      field: "transaction_id",
      headerName: "Id",
      flex: 1,
    },
    {
      field: "transaction_date",
      headerName: "DateTime",
      flex: 1,
      renderCell:(params) => <FormatedDate value={params.row.transaction_date}/>
    },
    {
      field: "commodity",
      headerName: "Commodity",
      flex: 1,
    },
    {
      field: "amount_of_commodity",
      headerName: "Bags Stored",
      flex: 1,
    },
    {
      field: "cash_value",
      headerName: "Cash value(GHS)",
      flex: 1,
      renderCell:(params) => currencyFormat.format(params.row.cash_value)
    },
    {
      field: "transaction_type_id",
      headerName: "Act",
      flex: 1,
      renderCell:(params) => params.row.transaction_type_id === 1?'Store':  'Retrieve'
    },
    {
      field: "grade",
      headerName: "Grade",
      flex: 1,
    },
    {
      field: "unit_per_kg",
      headerName: "Units(kg)",
      flex: 1,
    },
    {
      field: "username",
      headerName: "Prepared by",
      flex: 1,
    },
    {
      field: "total_cash_balance",
      headerName: "Cash Balance",
      flex: 1,
      renderCell:(params) => currencyFormat.format(params.row.total_cash_balance)
    },
    {
      field: "view",
      type:'actions',
      width:20,
      getActions: (params: GridRowParams) => [
      <GridActionsCellItem
      icon={<SummarizeIcon />}
      onClick={() => handle_print_all({params})} 
      label="View"
      />,]
    },
    {
      field: 'delete',
      type: 'actions',
      width:20,
      getActions: (params: GridRowParams) => [
      <GridActionsCellItem
      icon={<DeleteIcon />}
      onClick={() => handleClickOpen(params.row.transaction_id)} 
      label="Open"
      />,]
    },
  ]
  const [date, setDate] = useState()

  const handle_print_all = async ({ params }) => {
    setMini_loading(true)
    setDate(params.row.transaction_date);
    await proccess_info_all({ params });
  };

  const [confirm_request_all, setConfirm_request_all] = useState([]);
  const [processingComplete_all, setProcessingComplete_all] = useState(false);
  const [fees, setFees] = useState([]);
  const [modal_Open_no_all, setModal_open_no_all] = useState(false)
  const [modal_Open_no_ret_all, setModal_open_no_ret_all] = useState(false);
  
  const proccess_info_all = ({params}) => {
    api.get(`/account/act/details/edit/${params.row.transaction_id}` ,{
      headers: {
        Authorization: 'Bearer ' + fetchToken()
      }
    }).then(function (response){
        setFees(response.data?.details)
      const data = new FormData()
      data.append('commodity_id', params.row.id)
      data.append('grade_id', response.data?.details.grade_id)
      data.append('unit_id', response.data?.details.units_id)
      data.append('amount_storing', response.data?.details.amount_of_commodity)
      data.append('member_com_acc', props.ID)
      data.append('rebag', response.data?.details.rebagging_fee)
      data.append('stack', response.data?.details.stacking_fee)
      data.append('clean', response.data?.details.cleaning_fee)
      data.append('destone', response.data?.details.destoning_fee)
      data.append('store', response.data?.details.storage_fee)
      data.append('stitch', response.data?.details.stitching_fee)
      data.append('load', response.data?.details.loading_fee)
      data.append('empty_sack', response.data?.details.empty_sack_cost_fee)
      api.post('/account/process/storage', data ,{
        headers: {
          Authorization: 'Bearer ' + fetchToken()
        }
      }).then(function (response){
        setConfirm_request_all(response.data);
        setProcessingComplete_all(true);
        if (params.row.transaction_type_id === 2){
          setModal_open_no_ret_all(true)
        }else{
          setModal_open_no_all(true)
        }
      }).catch(function (error){
        console.log(error)
      })

    }).catch(function (error){
      console.log(error)
    })
  }


  

  const CustomFooterRow = () => {
    return (
      <div>
        <div style={{ display: 'flex', padding: '4px' }}>
          <Typography variant="h6" sx={{ mr:4 }}><b>Total:</b></Typography>
          <Typography variant="h6" sx={{ mr:4 }}><b>Cash Value: {currencyFormat.format(total_cash_value)}</b> </Typography>
          <Typography variant="h6" sx={{ mr:4 }}><b>Bags: {total_bags}</b> </Typography>
          <Typography variant="h6" sx={{ mr:4 }}><b>Cash Balance: {currencyFormat.format(total_balance)}</b> </Typography>
         </div>
      </div>
    );
  }

  const sec_style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 620,
    maxHeight: '80vh', 
    overflowY: 'auto', 
    bgcolor: 'background.paper',
    border: '1px solid #e7ecef',
    borderRadius: '7px',
    boxShadow: 24,
    p: 4,
  };

  const closeam_all = () => {
    setMini_loading(false)
    setModal_open_no_all(false)
  }

  const handle_modal_Closee_ret_all = () => {
    setModal_open_no_ret_all(false)
  }
  


  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
    <div>
        <Item>
            <Box
                sx={{
                     display:'flex',
                     justifyContent:'space-between'
                    }}
            >
                {/* <Typography>Current Amount of commodities: {info[0]?.amount_of_commodities}</Typography> */}
                {/* <Typography>Open date: {info[0]?.open_date}</Typography> */}
                <Typography>Total Number of commodities: </Typography>
            </Box>
            <Box
                sx={{ 
                    display:'flex-end',
                    mb:4
                 }}
            >
                {/* <ButtonGroup variant="contained" aria-label="outlined primary button group"> */}
                    <Button variant='contained' color='info' sx={{ marginRight:'7px' }} onClick={handleStore}>Store Commodity</Button>
                    <Button variant='contained' color='error' sx={{ marginRight:'7px' }} onClick={handleRetrieve}>Retrieve Commodity</Button>
                    <Button variant='contained' color='success' onClick={tradingAccount}>Trading Account</Button>
                {/* </ButtonGroup> */}
            </Box>
            <div>
              <Button
                onClick={openoo_open}
                sx={{ borderRadius: 6, backgroundColor: 'blueviolet' }}
                size='medium'
                variant='contained'
                startIcon={<AssignmentIcon />}
              >
                <b><i>See All Activities</i></b>
              </Button>
            </div>
            
                 <Typography sx={{mt:1, textAlign:'left'}} variant='subtitle' fontStyle='Italic'>My Commodities</Typography>
            <div style={{ display:'flex', margin:'0 2px 4px' }}>
              {
                more_details_i_like[0]?
                more_details_i_like.map((item)=>(
                  <Tooltip title="Click to view details" leaveDelay={300} followCursor>
                    <Chip key={item.id} label={<b><i>{item.commodity}</i></b>} sx={{  backgroundColor:'#d4a276', color:'#000', m:1 }} onClick={() => handleInfoDo(
                      item.commodity,
                      item.units,
                      item.total_number,
                      item.commodity_cash_value,
                      item.total_weight,
                      item.tonnes,
                      item.grade,
                      item.id
                    )} />
                  </Tooltip>
                ))
                :
                  <Box sx={{ width: '100%', justifyContent:'center' }}>
                   {/* <CircularProgress /> */}
                   <Typography variant='subtitle'>Opps you have no commodity stored</Typography>
                  </Box>
              }
            </div>
            {info_do}
            
                <Button variant='contained' color='warning' onClick={handleClose}>Close</Button>
                <Button
                  sx={{ m:2 }}
                  onClick={()=>setOpen(true)}
                  variant='contained'
                  color='warning'
                >
                    Delete Account
                </Button>
        </Item>
        <Dialog open={StorageForm} onClose={closeStore}>
            <form onSubmit={formik.handleSubmit}>
            <DialogTitle>Store Commodities</DialogTitle>
            <DialogContent>
            <DialogContentText>
                Storage Form
            </DialogContentText>
              <Autocomplete
                  disablePortal
                  id="combo-box-demo"
                  options={commodities_info}
                  sx={{ width: 300, mt:3, marginBottom:1 }}
                  getOptionLabel={(option) => option.commodity}
                  isOptionEqualToValue={(option, value) => option.id === value.id}
                  onChange={(event, value) => {
                      if (value) {
                          formik.setFieldValue("commodity_id", value.id)
                      }
                  }}
                  renderInput={(params) => <TextField {...params} label="Select Commodity" size="small" />}
              />

            {
              grade_price[0]?
              <>
              <Select
                margin="dense"
                required
                name="grade_id"
                onChange={formik.handleChange}
                value={formik.values.grade_id}
                fullWidth
                size='small'
                variant="outlined"
               
              >
            {
              grade_price.map((item) => (
                <MenuItem value={item.id}>{item.grade}</MenuItem>
              ))
            }
          </Select>
          <FormHelperText sx={{ marginBottom:1 }}>Set Grade</FormHelperText>

          <Select
            margin="dense"
            required
            name="unit_id"
            onChange={(e) => {
              const selectedUnit = available_units.find(unit => unit.id === e.target.value);
              setUnit_now(selectedUnit.unit_per_kg);
              formik.setFieldValue("unit_id", e.target.value);
            }}
            value={formik.values.unit_id}
            fullWidth
            size='small'
            variant="outlined"
          >
            {
              available_units.map((item) => (
                <MenuItem key={item.id} value={item.id}>
                  {item.unit_per_kg}
                </MenuItem>
              ))
            }
          </Select>
          <FormHelperText sx={{ marginBottom:1 }}>Set Unit\kg</FormHelperText>
          
          </>
              : null
            }
            <TextField
                margin="dense"
                name="amount_storing"
                id="amount_storing"
                value={formik.values.amount_storing}
                onChange={formik.handleChange}
                helperText="Number of bags"
                type="number"
                fullWidth
                size="small"
                variant="outlined"
            />
            <TextField
                id="date"
                name="date" 
                value={formik.values.date}
                onChange={formik.handleChange}
                type="date"
                label="Set Date"
                size="small"
                sx={{ mb:2, mt:1 }}
            />
            
            <Typography variant='h5' sx={{ color:'darkblue' }}>Charges (per bag)</Typography>
          {
            charges[0]
            ?
            <FormGroup>
              <FormControlLabel control={<Checkbox name='rebag' checked={formik.values.rebag} onChange={formik.handleChange} />} label={`Rebag (${currencyFormat.format(unit_now === 50?charges[0].rebagging_fee:charges[0].rebagging_fee *2)})`} />
              <FormControlLabel control={<Checkbox name='stack' checked={formik.values.stack} onChange={formik.handleChange} />} label={`Stack (${currencyFormat.format(unit_now === 50?charges[0].stacking_fee:charges[0].stacking_fee *2)})`} />
              <FormControlLabel control={<Checkbox name='clean' checked={formik.values.clean} onChange={formik.handleChange} />} label={`Clean (${currencyFormat.format(unit_now === 50?charges[0].cleaning_fee:charges[0].cleaning_fee *2)})`} />
              <FormControlLabel control={<Checkbox name='destone' checked={formik.values.destone} onChange={formik.handleChange} />} label={`Disstone (${currencyFormat.format(unit_now === 50?charges[0].destoning_fee:charges[0].destoning_fee *2)})`} />
              <FormControlLabel control={<Checkbox name='store' checked={formik.values.store} onChange={formik.handleChange} />} label={`Store (${currencyFormat.format(unit_now === 50?charges[0].storage_fee:charges[0].storage_fee *2)})`} disabled />
              <FormControlLabel control={<Checkbox name='stitch' checked={formik.values.stitch} onChange={formik.handleChange} />} label={`Stitch (${currencyFormat.format(unit_now === 50?charges[0].stitching_fee:charges[0].stitching_fee *2)})`} />
              <FormControlLabel control={<Checkbox name='load' checked={formik.values.load} onChange={formik.handleChange} />} label={`Load (${currencyFormat.format(unit_now === 50?charges[0].loading_fee:charges[0].loading_fee *2)})`} disabled />
              <FormControlLabel control={<Checkbox name='empty_sack' checked={formik.values.empty_sack} onChange={formik.handleChange} />} label={`Sack (${currencyFormat.format(unit_now === 50?charges[0].empty_sack_cost_fee:charges[0].empty_sack_cost_fee *2)})`} />
              <FormControlLabel control={<Checkbox checked={true} />} label={`Tax (GHS ${unit_now === 50?charges[0].tax_fee:charges[0].tax_fee*2})`} disabled />
            </FormGroup>
            :
            <Box sx={{ width: '100%', justifyContent:'center' }}>
                <CircularProgress size='15'/>
            </Box>
          }
          



            </DialogContent>
            <DialogActions>
            <Button
              variant='contained'
              onClick={closeStore}
              color='error'
              size='small'
            >
                Cancel
            </Button>

            <Button
              variant='contained'
              type='submit'
              color='success'
              size='small'
              disabled={
                formik.values.amount_storing && formik.values.unit_id && formik.values.commodity_id && formik.values.grade_id ?
                false: true
              }
            >
              Process
            </Button>
            
            </DialogActions>
            </form>
          <Backdrop
            sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
            open={openn}
            onClick={handleCloses}
          >
            <div className="wrapper">
              <div className="circle"></div>
              <div className="circle"></div>
              <div className="circle"></div>
              <div className="shadow"></div>
              <div className="shadow"></div>
              <div className="shadow"></div>
            </div>
          </Backdrop>
        </Dialog>


        {/* Retrieval Form */}

        <Dialog
          open={RetrievalForm}
          onClose={closeRetrive}
          fullWidth
          maxWidth='sm'
        >
            <form onSubmit={reformik.handleSubmit}>
            <DialogTitle>Retrieve Commodities</DialogTitle>
            <DialogContent>
            <DialogContentText>
                Retrieval Form
            </DialogContentText>
              <Autocomplete
                  disablePortal
                  id="combo-box-demo"
                  options={more_details_i_like}
                  sx={{ width: 300, mt:3, marginBottom:1 }}
                  getOptionLabel={(option) => option.commodity}
                  isOptionEqualToValue={(option, value) => option.id === value.id}
                  onChange={(event, value) => {
                      if (value) {
                          reformik.setFieldValue("commodity_id", value.id)
                      }
                  }}
                  renderInput={(params) => <TextField {...params} label="Select Commodity" size="small" />}
              />

            {
              responsible_trs?
              <>
              <Typography sx={{ textAlign: 'center', color:'#780000' }} variant='subtitle' fontFamily='Monospace' fontStyle='oblique'>
              Activities with all their bags retrieved or already in the market will not be displayed here.
              </Typography>
              <Autocomplete
                  disablePortal
                  id="combo-box-demo"
                  options={responsible_trs}
                  sx={{ mt:3, marginBottom:1 }}
                  getOptionLabel={(option) => `Activity id: ${option.id}`}
                  renderOption={(props, option) => (
                    <li {...props}>
                      <DemChips 
                        id={option.id} 
                        date={option.date} 
                        cash={currencyFormat.format(option.cash_worth)} 
                        grade={option.grade} 
                        unit={option.unit} 
                        bags={option.bags}/>
                    </li>
                  )}
                  isOptionEqualToValue={(option, value) => option.id === value.id}
                  onChange={(event, value) => {
                      if (value) {
                          reformik.setFieldValue("transaction_id", value.id)
                      }
                  }}
                  renderInput={(params) => 
                  <TextField {...params} 
                    fullWidth  
                    label="Select Activity" 
                    size="small" 
                  />}
              />

            <TextField
                margin="dense"
                name="amount_retrieving"
                value={reformik.values.amount_retrieving}
                onChange={reformik.handleChange}
                onBlur={reformik.handleBlur}
                error={reformik.touched.amount_retrieving && Boolean(reformik.errors.amount_retrieving)}
                helperText={reformik.touched.amount_retrieving && reformik.errors.amount_retrieving}
                label="Number of bags"
                type="number"
                fullWidth
                size="small"
                variant="outlined"
            />
              </>
              : <div style={{ marginBottom:2 }}><Typography variant='subtitle' fontStyle='Italic' sx={{ color:'#780000' }}>
                  Select the commodity for its activities. When retrieving, use the storage activities to take either the full quantity or a specified number of bags.
                </Typography></div>
            }
            {
              num_komot?
              <Typography sx={{ textAlign: 'center' }} variant='body1' fontFamily='Monospace' fontStyle='oblique'>Bags left: <b>{num_komot}</b></Typography>
              :
              null
            }

            <TextField
                id="date"
                name="date" 
                value={reformik.values.date}
                onChange={reformik.handleChange}
                type="date"
                label="Set Date"
                size="small"
                sx={{ mb:2, mt:1 }}
            />
            
            
            </DialogContent>
            <DialogActions>
            <Button
              variant='contained'
              onClick={closeRetrive}
              color='error'
              size='small'
            >
                Cancel
            </Button>

            <Button
              variant='contained'
              type='submit'
              color='success'
              size='small'
              disabled={
                reformik.values.amount_retrieving  && reformik.values.commodity_id && reformik.values.transaction_id && reformik.values.date ?
                false: true
              }
            >
              Process
            </Button>
            
            </DialogActions>
            </form>
          <Backdrop
            sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
            open={openn}
            onClick={handleCloses}
          >
            <CircularProgress color="inherit" />
          </Backdrop>
        </Dialog>
 
        <Dialog
            open={open}
            onClose={() =>setOpen(false)}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <DialogTitle id="alert-dialog-title">
            {"Delete Account"}
            </DialogTitle>
            <DialogContent>
            <DialogContentText id="alert-dialog-description">
                This action cannot be undone. NB: this will also delete all
                transactions in this account. As well as your Commodity details.
                Do you wish to continue?
            </DialogContentText>
            </DialogContent>
            <DialogActions>
            <Button onClick={handleClose}>Cancel</Button>
            <Button onClick={handleDeleteAcc} autoFocus>
                Continue
            </Button>
            </DialogActions>
        </Dialog>

        <Modal
            open={modal_Open}
            onClose={handle_modal_Closee}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
        >
              {
                confirm_request?
          <Box sx={style}>
                  <>
                    <div ref={printRef} style={{ display:'block', marginBottom:5 }}>
                        <Typography fontStyle='Italic' variant='body2' sx={{ textAlign: 'center',mb:2}}>~The Cooperative~</Typography>

                        <Typography variant='h5' fontStyle='italic'>Commodity Storage</Typography>
                        <Chip sx={{ display:'flex', mt:1, mb:1  }} label={confirm_request.Commodity} variant='outlined' color='success'/>
                        <Divider variant='middle' sx={{mt:1, mb:1}}><i>Member Details</i></Divider>
                        <div>
                          <Typography fontStyle='Italic' variant='body2'>Date: <b style={{color:'black'}}> <FormatedDate value={formik.values.date}/></b></Typography>
                          <Typography fontStyle='Italic' variant='body2'>Member: <b style={{color:'black'}}>{props.member}</b></Typography>
                          <Typography fontStyle='Italic' variant='body2'>Passbook: <b style={{color:'black'}}>{props.passbook}</b></Typography>
                          <Typography fontStyle='Italic' variant='body2'>Society: <b style={{color:'black'}}>{props.society}</b></Typography>
                          <Typography fontStyle='Italic' variant='body2'>Kind: <b style={{color:'black'}}>{props.kind}</b></Typography>
                          <Typography fontStyle='Italic' variant='body2'>Savings Group: <b style={{color:'black'}}>{props.association}</b></Typography>
                          <Typography fontStyle='Italic' variant='body2'>Warehouse: <b style={{color:'black'}}>{props.name}</b></Typography>
                        </div>

                        <Divider variant='middle' sx={{mt:2, mb:2}}><i>Commodity Specification</i></Divider>
                      <div style={{ display:'flex', justifyContent:'space-between' }}>
                        <div style={{ display:'block' }}>
                          <Typography variant='h6' fontStyle='italic'>Grade: <b>{confirm_request.Grade}</b> </Typography>
                          <Typography variant='h6' fontStyle='italic'>Current {confirm_request.Commodity} price: <b>{currencyFormat.format(confirm_request.Current_commodity_price)}</b> </Typography>
                          <Typography variant='h6' fontStyle='italic'>Number of Bags: <b>{confirm_request.Amount_storing} </b> </Typography>
                          <Typography variant='h6' fontStyle='italic'>Units: <b>{confirm_request.Unit_kg}kg</b> </Typography>
                          <Typography variant='h6' fontStyle='italic'>Weight: <b>{confirm_request.Weight}kg </b> </Typography>
                          <Typography variant='h6' fontStyle='italic'>Tonnes: <b>{confirm_request.Tons}</b> </Typography>
                          <Typography variant='h6' fontStyle='italic'>Price per bag (Original): <b>{currencyFormat.format(confirm_request.Price_per_bag)}</b> </Typography>
                          <Typography variant='h6' fontStyle='italic'>Price per bag (Charged): <b>{currencyFormat.format(confirm_request.charged_price_per_bg)}</b> </Typography>
                          <Typography variant='h6' fontStyle='italic'>Current cash value: <b>{currencyFormat.format(confirm_request.total_cash_value)}</b> </Typography>
                        </div>
                        <div style={{ display:'block', marginLeft:'3px', borderColor:'blue' }}>
                          {
                            charges[0]?
                            <>
                              <Typography variant='subtitle' fontStyle='oblique' fontFamily='Futura'><b><u>Charges associated</u></b></Typography>
                              <Typography variant='h6' fontStyle='italic'>Rebag ({currencyFormat.format(charges[0].rebagging_fee)}): <b>{formik.values.rebag === true? 'paid':'no rebaging'}</b> </Typography>
                              <Typography variant='h6' fontStyle='italic'>Stack ({currencyFormat.format(charges[0].stacking_fee)}): <b>{formik.values.stack === true? 'paid':'no stacking'}</b> </Typography>
                              <Typography variant='h6' fontStyle='italic'>Clean ({currencyFormat.format(charges[0].cleaning_fee)}): <b>{formik.values.clean === true? 'paid':'no cleaning'}</b> </Typography>
                              <Typography variant='h6' fontStyle='italic'>Destone ({currencyFormat.format(charges[0].destoning_fee)}): <b>{formik.values.destone === true? 'paid':'no destoning'}</b> </Typography>
                              <Typography variant='h6' fontStyle='italic'>Store ({currencyFormat.format(charges[0].storage_fee)}): <b>{formik.values.store === true? 'paid':'no storage_fee'}</b> </Typography>
                              <Typography variant='h6' fontStyle='italic'>Stitch ({currencyFormat.format(charges[0].stitching_fee)}): <b>{formik.values.stitch === true? 'paid':'no stitching'}</b> </Typography>
                              <Typography variant='h6' fontStyle='italic'>Load ({currencyFormat.format(charges[0].loading_fee)}): <b>{formik.values.load === true? 'paid':'no loading'}</b> </Typography>
                              <Typography variant='h6' fontStyle='italic'>Empty Sack ({currencyFormat.format(charges[0].empty_sack_cost_fee)}): <b>{formik.values.empty_sack === true? 'paid':'no empty sack'}</b> </Typography>
                              <Typography variant='h6' fontStyle='italic'>Tax ({currencyFormat.format(charges[0].tax_fee)}): <b>paid</b> </Typography>
                            </>
                            :
                            <Box sx={{ width: '100%', justifyContent:'center' }}>
                                <CircularProgress size='15'/>
                            </Box>
                          }
                        
                        </div>
                      </div>
                        
                    </div>
                        <Typography sx={{ mt:2 }} variant='subtitle' fontStyle='italic'>Print:</Typography>
                        <IconButton onClick={handlePrint}><SummarizeIcon size='small'/></IconButton>
                    <div style={{ display:'flex', flexDirection: 'row', marginLeft:320 }}>
                    <Button
                      variant='contained'
                      onClick={handle_modal_Closee}
                      color='error'
                      size='small'
                      sx={{ mr:1 }}
                    >
                        Cancel
                    </Button>

                    <Button
                      variant='contained'
                      color='success'
                      size='small'
                      onClick={handleConfirmOrder}
                      disabled={loading === true? true:false}
                    >
                       Confirm
                    </Button>
                    </div>
                  </>
          </Box>
                :
                <Box sx={{ width: '100%', justifyContent:'center' }}>
                  <CircularProgress size='15'/>
                </Box>
              }
        </Modal>



              {/* Retrieval */}
        <Modal
            open={modal_Open_ret}
            onClose={handle_modal_Closee_ret}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
        >
              {
                confirm_request_ret?
            <Box sx={style}>
                  <>
                    <div ref={printRef_ret} style={{ display:'block', marginBottom:5 }}>
                        <Typography fontStyle='Italic' variant='body2' sx={{ textAlign: 'center',mb:2}}>~The Cooperative~</Typography>

                        <Typography variant='h5' fontStyle='italic'>Commodity Retrieval</Typography>
                        <Chip sx={{ display:'flex', mt:1, mb:1  }} label={confirm_request.Commodity} variant='outlined' color='success'/>
                        <Divider variant='middle' sx={{mt:1, mb:1}}><i>Member Details</i></Divider>
                        <div>
                          <Typography fontStyle='Italic' variant='body2'>Date: <b style={{color:'black'}}> <FormatedDate value={reformik.values.date}/></b></Typography>
                          <Typography fontStyle='Italic' variant='body2'>Member: <b style={{color:'black'}}>{props.member}</b></Typography>
                          <Typography fontStyle='Italic' variant='body2'>Passbook: <b style={{color:'black'}}>{props.passbook}</b></Typography>
                          <Typography fontStyle='Italic' variant='body2'>Society: <b style={{color:'black'}}>{props.society}</b></Typography>
                          <Typography fontStyle='Italic' variant='body2'>Kind: <b style={{color:'black'}}>{props.kind}</b></Typography>
                          <Typography fontStyle='Italic' variant='body2'>Savings Group: <b style={{color:'black'}}>{props.association}</b></Typography>
                          <Typography fontStyle='Italic' variant='body2'>Warehouse: <b style={{color:'black'}}>{props.name}</b></Typography>
                        </div>

                        <Divider variant='middle' sx={{mt:2, mb:2}}><i>Commodity Specification</i></Divider>

                        <Typography variant='h6' fontStyle='italic'>Grade: <b>{confirm_request_ret.Grade}</b> </Typography>
                        <Typography variant='h6' fontStyle='italic'>Current {confirm_request_ret.Commodity} price: <b>{currencyFormat.format(confirm_request_ret.Current_commodity_price)}</b> </Typography>
                        <Typography variant='h6' fontStyle='italic'>Bags retrieving: <b>{confirm_request_ret.Amount_storing} </b> </Typography>
                        <Typography variant='h6' fontStyle='italic'>Units: <b>{confirm_request_ret.Unit_kg}kg</b> </Typography>
                        <Typography variant='h6' fontStyle='italic'>Weight: <b>{confirm_request_ret.Weight}kg </b> </Typography>
                        <Typography variant='h6' fontStyle='italic'>Tonnes: <b>{confirm_request_ret.Tons}</b> </Typography>
                        <Typography variant='h6' fontStyle='italic'>Price per bag (Charged): <b>{currencyFormat.format(confirm_request_ret.Price_per_bag)}</b> </Typography>
                        <Typography variant='h6' fontStyle='italic'>Value: <b>{currencyFormat.format(confirm_request_ret.total_cash_value)}</b> </Typography>
                       
                        
                    </div>
                        <Typography sx={{ mt:2 }} variant='subtitle' fontStyle='italic'>Print:</Typography>
                        <IconButton onClick={handlePrint_ret}><SummarizeIcon size='small'/></IconButton>
                    <div style={{ display:'flex', flexDirection: 'row', marginLeft:320 }}>
                    <Button
                      variant='contained'
                      onClick={handle_modal_Closee_ret}
                      color='error'
                      size='small'
                      sx={{ mr:1 }}
                    >
                        Cancel
                    </Button>

                    <Button
                      variant='contained'
                      color='success'
                      size='small'
                      onClick={handleConfirmOrder_ret}
                      disabled={loading === true? true:false}
                    >
                       {loading === true? "Loading...":"Confirm"}
                       
                    </Button>
                    </div>
                  </>
          </Box>
                :
                <Box sx={{ width: '100%', justifyContent:'center' }}>
                  <CircularProgress size='15'/>
                </Box>
              }
        </Modal>

        {/* all activities */}
        <Modal
            open={Modal_open_all}
            onClose={handle_modal_Closee_all}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
        >
          <Box sx={styler}>
          <Typography variant="button" display="block" gutterBottom><b>All My Activities</b></Typography>
              <>
                <Typography>Filter Date</Typography>
                <div style={{ display:'flex' }}>
                <TextField
                    type='date'
                    size="small"
                    required 
                    variant="outlined"
                    helperText="From"
                    name="start_date_all"
                    onChange={(e) => setStart_date_all(e.target.value)}
                    value={start_date_all}
                    sx={{ mr:1 }}
                />

                <TextField
                    type='date'
                    size="small"
                    required
                    variant="outlined"
                    helperText="To"
                    name="end_date_all"
                    onChange={(e) => setEnd_date_all(e.target.value)}
                    value={end_date_all}
                    sx={{ mr:1 }}
                />

                  <IconButton sx={{ mb:2 }} onClick={fetch_activities_all}><FilterAltOutlinedIcon /></IconButton>
                  <IconButton sx={{ mb:2 }} onClick={clear_filter_all}><CancelIcon /></IconButton>
                </div>
              </>
              <DataGrid
                  rows={acts_all}
                  columns={columns_all}
                  loading={mini_loading}
                  checkboxSelection
                  getRowId={(row) => row.transaction_id}
                  sortingOrder={['desc', 'asc']}
                  sortModel={[
                  {
                      field: 'transaction_id',
                      sort: 'desc',
                  },
                  ]}
                  slots={{ toolbar: GridToolbar, footer: CustomFooterRow }}
                  initialState={{
                      columns: {
                        columnVisibilityModel: {
                          transaction_id: false,
                          id: false
                        },
                      },
                    }}
              />
              <Button
                onClick={handle_modal_Closee_all}
                sx={{ borderRadius: 3, mt:3 }}
                size='small'
                color='error'
                variant='contained'
              >
                Close
              </Button>
          </Box>
        </Modal>

        {/* save */}
        <Modal
            open={modal_Open_no_all}
            onClose={closeam_all}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
        >
              {
                confirm_request_all?
          <Box sx={sec_style}>
                  <>
                    <div ref={printRef} style={{ display:'block', marginBottom:5 }}>
                        <Typography fontStyle='Italic' variant='body2' sx={{ textAlign: 'center',mb:2}}>~The Cooperative~</Typography>

                        <Typography variant='h5' fontStyle='italic'>Commodity Storage</Typography>
                        <Chip sx={{ display:'flex', mt:1, mb:1  }} label={confirm_request_all.Commodity} variant='outlined' color='success'/>
                        <Divider variant='middle' sx={{mt:1, mb:1}}><i>Member Details</i></Divider>

                        <div>
                          <Typography fontStyle='Italic' variant='body2'>Date: <b style={{color:'black'}}> <FormatedDate value={date}/></b></Typography>
                          <Typography fontStyle='Italic' variant='body2'>Member: <b style={{color:'black'}}>{props.member}</b></Typography>
                          <Typography fontStyle='Italic' variant='body2'>Passbook: <b style={{color:'black'}}>{props.passbook}</b></Typography>
                          <Typography fontStyle='Italic' variant='body2'>Society: <b style={{color:'black'}}>{props.society}</b></Typography>
                          <Typography fontStyle='Italic' variant='body2'>Kind: <b style={{color:'black'}}>{props.kind}</b></Typography>
                          <Typography fontStyle='Italic' variant='body2'>Savings Group: <b style={{color:'black'}}>{props.association}</b></Typography>
                          <Typography fontStyle='Italic' variant='body2'>Warehouse: <b style={{color:'black'}}>{props.name}</b></Typography>
                        </div>

                        <Divider variant='middle' sx={{mt:2, mb:2}}><i>Commodity Specification</i></Divider>
                        <div style={{ display:'flex', justifyContent:'space-between' }}>
                        <div style={{ display:'block' }}>
                          <Typography variant='h6' fontStyle='italic'>Grade: <b>{confirm_request_all.Grade}</b> </Typography>
                          <Typography variant='h6' fontStyle='italic'>Current {confirm_request_all.Commodity} price: <b>{currencyFormat.format(confirm_request_all.Current_commodity_price)}</b> </Typography>
                          <Typography variant='h6' fontStyle='italic'>Number of Bags: <b>{confirm_request_all.Amount_storing} </b> </Typography>
                          <Typography variant='h6' fontStyle='italic'>Units: <b>{confirm_request_all.Unit_kg}kg</b> </Typography>
                          <Typography variant='h6' fontStyle='italic'>Weight: <b>{confirm_request_all.Weight}kg </b> </Typography>
                          <Typography variant='h6' fontStyle='italic'>Tonnes: <b>{confirm_request_all.Tons}</b> </Typography>
                          <Typography variant='h6' fontStyle='italic'>Price per bag (Original): <b>{currencyFormat.format(confirm_request_all.Price_per_bag)}</b> </Typography>
                          <Typography variant='h6' fontStyle='italic'>Price per bag (Charged): <b>{currencyFormat.format(confirm_request_all.charged_price_per_bg)}</b> </Typography>
                          <Typography variant='h6' fontStyle='italic'>Current cash value: <b>{currencyFormat.format(confirm_request_all.total_cash_value)}</b> </Typography>
                        </div>
                        <div style={{ display:'block', marginLeft:'3px', borderColor:'blue' }}>
                          {
                            charges[0]?
                            <>
                              <Typography variant='subtitle' fontStyle='oblique' fontFamily='Futura'><b><u>Charges associated</u></b></Typography>
                              <Typography variant='h6' fontStyle='italic'>Rebag ({currencyFormat.format(charges[0].rebagging_fee)}): <b>{fees.rebagging_fee === true? 'paid':'no rebaging'}</b> </Typography>
                              <Typography variant='h6' fontStyle='italic'>Stack ({currencyFormat.format(charges[0].stacking_fee)}): <b>{fees.stacking_fee === true? 'paid':'no stacking'}</b> </Typography>
                              <Typography variant='h6' fontStyle='italic'>Clean ({currencyFormat.format(charges[0].cleaning_fee)}): <b>{fees.cleaning_fee === true? 'paid':'no cleaning'}</b> </Typography>
                              <Typography variant='h6' fontStyle='italic'>Destone ({currencyFormat.format(charges[0].destoning_fee)}): <b>{fees.destone === true? 'paid':'no destoning'}</b> </Typography>
                              <Typography variant='h6' fontStyle='italic'>Store ({currencyFormat.format(charges[0].storage_fee)}): <b>{fees.storage_fee === true? 'paid':'no storage_fee'}</b> </Typography>
                              <Typography variant='h6' fontStyle='italic'>Stitch ({currencyFormat.format(charges[0].stitching_fee)}): <b>{fees.stitching_fee === true? 'paid':'no stitching'}</b> </Typography>
                              <Typography variant='h6' fontStyle='italic'>Load ({currencyFormat.format(charges[0].loading_fee)}): <b>{fees.loading_fee === true? 'paid':'no loading'}</b> </Typography>
                              <Typography variant='h6' fontStyle='italic'>Empty Sack ({currencyFormat.format(charges[0].empty_sack_cost_fee)}): <b>{fees.empty_sack_cost_fee === true? 'paid':'no empty sack'}</b> </Typography>
                              <Typography variant='h6' fontStyle='italic'>Tax ({currencyFormat.format(charges[0].tax_fee)}): <b>paid</b> </Typography>
                            </>
                            :
                            <Box sx={{ width: '100%', justifyContent:'center' }}>
                                <CircularProgress size='15'/>
                            </Box>
                          }
                        
                        </div>
                      </div>

                    </div>
                        <Typography sx={{ mt:2 }} variant='subtitle' fontStyle='italic'>Print:</Typography>
                        <IconButton onClick={handlePrint}><SummarizeIcon size='small'/></IconButton>
                    <div style={{ display:'flex', flexDirection: 'row', marginLeft:320 }}>
                    <Button
                      variant='contained'
                      onClick={closeam_all}
                      color='error'
                      size='small'
                      sx={{ mr:1 }}
                    >
                        Cancel
                    </Button>
                    </div>
                  </>
          </Box>
                :
                <Box sx={{ width: '100%', justifyContent:'center' }}>
                  <CircularProgress size='15'/>
                </Box>
              }
        </Modal>

        {/* retriva */}
        <Modal
            open={modal_Open_no_ret_all}
            onClose={handle_modal_Closee_ret_all}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
              {
                confirm_request_all?
            <Box sx={sec_style}>
                  <>
                    <div ref={printRef_ret} style={{ display:'block', marginBottom:5 }}>
                        <Typography fontStyle='Italic' variant='body2' sx={{ textAlign: 'center',mb:2}}>~The Cooperative~</Typography>

                        <Typography variant='h5' fontStyle='italic'>Commodity Retrieval</Typography>
                        <Chip sx={{ display:'flex', mt:1, mb:1  }} label={confirm_request_all.Commodity} variant='outlined' color='success'/>
                        <Divider variant='middle' sx={{mt:1, mb:1}}><i>Member Details</i></Divider>
                        <div>
                          <Typography fontStyle='Italic' variant='body2'>Date: <b style={{color:'black'}}> <FormatedDate value={date}/></b></Typography>
                          <Typography fontStyle='Italic' variant='body2'>Member: <b style={{color:'black'}}>{props.member}</b></Typography>
                          <Typography fontStyle='Italic' variant='body2'>Passbook: <b style={{color:'black'}}>{props.passbook}</b></Typography>
                          <Typography fontStyle='Italic' variant='body2'>Society: <b style={{color:'black'}}>{props.society}</b></Typography>
                          <Typography fontStyle='Italic' variant='body2'>Kind: <b style={{color:'black'}}>{props.kind}</b></Typography>
                          <Typography fontStyle='Italic' variant='body2'>Savings Group: <b style={{color:'black'}}>{props.association}</b></Typography>
                          <Typography fontStyle='Italic' variant='body2'>Warehouse: <b style={{color:'black'}}>{props.name}</b></Typography>
                        </div>

                        <Divider variant='middle' sx={{mt:2, mb:2}}><i>Commodity Specification</i></Divider>

                        <Typography variant='h6' fontStyle='italic'>Grade: <b>{confirm_request_all.Grade}</b> </Typography>
                        <Typography variant='h6' fontStyle='italic'>Current {confirm_request_all.Commodity} price: <b>{currencyFormat.format(confirm_request_all.Current_commodity_price)}</b> </Typography>
                        <Typography variant='h6' fontStyle='italic'>Bags retrieving: <b>{confirm_request_all.Amount_storing} </b> </Typography>
                        <Typography variant='h6' fontStyle='italic'>Units: <b>{confirm_request_all.Unit_kg}kg</b> </Typography>
                        <Typography variant='h6' fontStyle='italic'>Weight: <b>{confirm_request_all.Weight}kg </b> </Typography>
                        <Typography variant='h6' fontStyle='italic'>Tonnes: <b>{confirm_request_all.Tons}</b> </Typography>
                        <Typography variant='h6' fontStyle='italic'>Price per bag (Charged): <b>{currencyFormat.format(confirm_request_all.Price_per_bag)}</b> </Typography>
                        <Typography variant='h6' fontStyle='italic'>Value: <b>{currencyFormat.format(confirm_request_all.total_cash_value)}</b> </Typography>
                       
                        
                    </div>
                        <Typography sx={{ mt:2 }} variant='subtitle' fontStyle='italic'>Print:</Typography>
                        <IconButton onClick={handlePrint_ret}><SummarizeIcon size='small'/></IconButton>
                    
                    <Button
                      variant='contained'
                      onClick={handle_modal_Closee_ret_all}
                      color='error'
                      size='small'
                      sx={{ mr:1 }}
                    >
                        Cancel
                    </Button>
                  </>
          </Box>
                :
                <Box sx={{ width: '100%', justifyContent:'center' }}>
                  <CircularProgress size='15'/>
                </Box>
              }
        </Modal>


        
        
          <Backdrop
            sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
            open={openn}
            onClick={handleCloses}
          >
            <CircularProgress color="inherit" />
          </Backdrop>
        <Snackbar
            open={ope}
            autoHideDuration={2000}
            onClose={handleClo}
            message={message}
            action={actio}
        />
    </div>
  </LocalizationProvider>
  )
}